<template>
  <div class="legend-item" :class="{ hidden: !show }">
    <icon-circle
      :disabled="!show"
      :style="{
        fill: style === 'line' ? 'none' : color,
        stroke: style === 'line' ? color : 'none',
      }"
      :bypass-default-color="true"
      strike-through-color="waterloo"
      :circle-style="style"
    />
    <span class="series-title rbz-text-regular">
      {{ title }}
    </span>
    <span class="series-subtitle rbz-text-small">
      {{ subtitle }}
    </span>
    <span class="amount rbz-text-small"> ({{ sum }}) </span>
  </div>
</template>

<script setup lang="ts">
import { Series } from 'uplot';
import IconCircle from 'ui-component-library/assets/icons/IconCircle.vue';
import { RbzSeriesStyle } from '@/types';

interface LegendItem {
  title: string;
  subtitle?: string;
  sum: string;
  show?: boolean;
  color?: Series.Stroke;
  style?: RbzSeriesStyle;
}

withDefaults(defineProps<LegendItem>(), {
  style: 'full',
});
</script>

<style scoped lang="scss">
@use 'ui-component-library/assets/styles/colors' as colors;
@use 'sass:map';

.legend-item {
  align-items: center;
  cursor: pointer;
  display: flex;
  gap: 2px;
  height: 24px;
  padding: 0 4px;
  white-space: nowrap;

  .series-title {
    color: map.get(colors.$colors, 'bright-gray');
  }

  .series-subtitle {
    color: map.get(colors.$colors, 'dusty-gray');
  }

  .amount {
    color: map.get(colors.$colors, 'dusty-gray');
  }

  &.hidden .series-title {
    text-decoration: line-through;
    text-decoration-color: map.get(colors.$colors, 'bright-gray');
  }

  &.hidden .series-subtitle {
    text-decoration: line-through;
    text-decoration-color: map.get(colors.$colors, 'dusty-gray');
  }

  &.hidden .amount {
    text-decoration: line-through;
    text-decoration-color: map.get(colors.$colors, 'dusty-gray');
  }
}
</style>
